import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AdminForm from "../../AdminForm";
import { selectLoading } from "features/admin/Tags/tagsAdminSlice";
import {
  selectInstallation,
  fetchInstallation,
  setInstallation,
  updateInstallation,
} from "../installationAdminSlice";
import Preloader from "components/Preloader/Preloader";
import styled from "styled-components/macro";

const EditInstallation = () => {
  const [progress, setProgress] = useState(0);
  const { id } = useParams();
  const dispatch = useDispatch();
  const installation = useSelector(selectInstallation);
  const isLoading = useSelector(selectLoading);
  const navigate = useNavigate();
  useEffect(() => {
    !isLoading && dispatch(fetchInstallation(id));
    return () => {
      dispatch(setInstallation(undefined));
    };
  }, [id]);

  const onSubmit = (data: any) => {
    dispatch(
      updateInstallation({ ...data, id }, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
    navigate(-1);
  };

  return !isLoading ? (
    <AdminForm
      formTitle="Промяна на цена за монтаж"
      onSubmit={onSubmit}
      product={installation}
      progress={progress}
    />
  ) : (
    <LoaderWrapper>
      <Preloader />
    </LoaderWrapper>
  );
};

export default EditInstallation;
const LoaderWrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: inline-flex;
  justify-content: center;
`;
